import { Icon } from '@iconify/react'
import Card from '../common/Card'

const ShopifyCard = ({ onGoToWebsiteConnections }) => {
  return (
    <Card
      title={
        <div className="flex items-center gap-4">
          <Icon icon="logos:shopify" className="text-4xl text-[#96bf48]" />
          <div>
            <h2 className="text-xl font-semibold">Shopify</h2>
            <p className="text-sm text-text-secondary">Connect your Shopify store for automated accessibility monitoring</p>
          </div>
        </div>
      }
    >
      <div className="space-y-4">
        <div className="p-4 bg-info/10 border border-info/20 rounded-lg">
          <p className="text-sm text-text-secondary">
            <strong>Note:</strong> To add a Shopify connection, go to the{' '}
            <button onClick={onGoToWebsiteConnections} className="text-primary hover:underline font-medium">
              Website Connections
            </button>{' '}
            page and select "Shopify" as the platform.
          </p>
        </div>
      </div>
    </Card>
  )
}

export default ShopifyCard
